import { isValidDate } from '@common/utils';
import cloneDeep from 'lodash/cloneDeep';
import { SPACE_REGEX } from 'mbs-ui-kit/utils/constants';

export function normalizeDateSpaces<T extends Record<string, any>>(items: T, keys: { dateKey: string; fromKey: string; toKey: string }): T {
  const { dateKey, fromKey, toKey } = keys;
  const clone = cloneDeep(items);
  const date = clone?.[dateKey];

  const normalizeField = (key: string) => {
    const raw = date?.[key];

    if (raw && typeof raw === 'string') {
      const replacedSpaces = raw.replace(SPACE_REGEX, ' ');

      date[key] = isValidDate(new Date(replacedSpaces)) ? replacedSpaces : null;
    }
  };

  normalizeField(fromKey);
  normalizeField(toKey);

  return clone;
}
